module.exports = __webpack_public_path__ + "img/cp-library-fisheries-1.64d08f71.svg";